import { Button, Drawer, Tag } from "antd";
import { Attendance, AttendanceStatus } from "../../../domains/models/attendance/attendance";
import { Clock } from "lucide-react";
import { getName, replaceSpaceWithHyphen } from "../../../utility/utility";
import React, { useEffect, useState } from "react";
import EmployeeAvatar from "../../employee/avatar/employee-avatar";
import dayjs from "dayjs";
import Locale from "../../../core/locale/locale";
import { fetchPunchDetails } from "../admin/actions";
import { mapPunchData } from "../utils";
import { History } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IPunchLogs {
    selectedRow: Attendance | null;
    onClose: () => void;
}

const PunchLogs: React.FC<IPunchLogs> = ({selectedRow, onClose}) => {

    const [punchDetails, setPunchDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (selectedRow) {
            handlePunchDetails(selectedRow);
        }
    }, [selectedRow])

    async function handlePunchDetails(record: Attendance) {
        setIsLoading(true);
        const res = await fetchPunchDetails(record.employeeId, record.date, record.date);
        const mappedData = mapPunchData(res);

        setPunchDetails(mappedData);
        setIsLoading(false);

    }


    function handleNavigationToStats() {
        const employeeId = selectedRow?.employeeId;
        navigate('/employee/attendance/stats', {state: {employeeId:employeeId}})
    }

    const formatDate = (date: string) => {
        return dayjs(date).format(Locale.displayDateLong);
    }

    const DrawerTitle = () => (
        <>
            {selectedRow && (
                <>
                    <EmployeeAvatar
                        name={selectedRow.employeeName}
                        thumbnailId={selectedRow.profilePhotoThumbnailId}
                        size={40}
                    />
                    <div>
                        <h4 className={'pn-attendance__drawer-title'}>{getName(selectedRow.employeeName.firstName,
                            selectedRow.employeeName.middleName,
                            selectedRow.employeeName.lastName) ?? ''}
                        </h4>
                        <span className={'pn-attendance__drawer-text'}>{formatDate(selectedRow.date)}</span>
                    </div>

                </>
            )}
        </>)

    return (
        <Drawer
            getContainer={false}
            open={Boolean(selectedRow)}
            onClose={onClose}
            closable={{placement: 'end'}}
            title={<DrawerTitle/>}
            className="pn-attendance__drawer"
        >
            <div className={'pn-attendance__drawer__card-wrapper'}>
                <div className={'pn-attendance__drawer__card'}>
                    <span className={'pn-attendance__drawer__card-title'}>In Time</span>
                    <span className={'pn-attendance__drawer__card-value'}>{selectedRow?.checkInTime}</span>

                </div>
                <div className={'pn-attendance__drawer__card'}>
                    <span className={'pn-attendance__drawer__card-title'}>Out Time</span>
                    <span className={'pn-attendance__drawer__card-value'}>{selectedRow?.checkOutTime}</span>
                </div>
                <div className={'pn-attendance__drawer__card'}>
                    <span className={'pn-attendance__drawer__card-title'}>Hours Logged</span>
                    <span className={'pn-attendance__drawer__card-value'}>{selectedRow?.workingHours}</span>
                </div>
                <div className={'pn-attendance__drawer__card'}>
                    <span className={'pn-attendance__drawer__card-title'}>Status</span>
                    <Tag
                        className={`pn-attendance__drawer__card-status-pill ${selectedRow?.status.toLowerCase()}`}>{AttendanceStatus[selectedRow?.status as keyof typeof AttendanceStatus]}</Tag>
                </div>
            </div>
            <div className="pn-attendance__drawer__detail">
                <div className="pn-attendance__drawer__detail-heading">
                    <Clock className={'clock-icon'}/>
                    <span className={'title'}>Punch timeline</span>
                </div>
                <LoadingSkeleton loading={isLoading}>
                    {punchDetails.length > 0 ? (
                        <div className={'pn-attendance__drawer__punch-timeline'}>
                            {punchDetails.map((punch: any) => (
                                <div className={'pn-attendance__drawer__detail-row'}
                                     key={punch.id}>
                                    <div className={'pn-attendance__drawer__detail-row__value'}>{punch.time}</div>
                                    <Tag
                                        className={`pn-attendance__drawer__detail-row__status-pill 
                                    ${replaceSpaceWithHyphen(punch.status)}`}>
                                        {punch.status}</Tag>
                                </div>))}
                        </div>
                    ) : (
                        <div className={'pn-attendance__drawer__detail-empty-container'}>
                            <History className={'pn-attendance__drawer__detail-empty-icon'}/>
                            <span className={'pn-attendance__drawer__detail-empty-text'}> No punches recorded</span>
                        </div>
                    )}
                </LoadingSkeleton>
            </div>

            <div className={'pn-attendance__drawer__footer'}>
                <span className={'pn-attendance__drawer__footer-text'}>Need more insights ?</span>
                <Button className={'btn-link'} type={'link'} onClick={handleNavigationToStats}>View Employee
                    Stats</Button>
            </div>
        </Drawer>
    )
}
export default PunchLogs;
